var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');
var variables = require('../variables.js');
var Debouncer = require('../lib/Debouncer.js');

function StickyNav() {
	if ($('.section--hasAside').length === 0)
		return;

	var defaultPadding = 20
		// Add more padding if WP admin bar present
		+ (document.body.classList.contains('admin-bar') ? 35 : 0)
	;

	var headingActiveClass = 'sectionNav__link--active';
	var $anchors = $('.sectionNav__link a');
	
	var enabled = true;
	$(window).on('scroll.scrollTo', new Debouncer(function() {
		if (!enabled)
			return;

		var scrollTop = $(window).scrollTop();
		var scrollBottom = scrollTop + $(window).height() - 50 /*padding*/;

		$('.' + headingActiveClass).removeClass(headingActiveClass);

		var makeActive = undefined;
		for (var i=0; i < $anchors.length; i++) {
			var $anchor = $($anchors[i]);
			var anchorHref = $anchor.attr('href');
			var anchor = anchorHref.substring(anchorHref.indexOf('#') + 1);
			var element = $('#' + anchor);
			var elementTop = element.offset().top;
			var elementBottom = elementTop + element.height();

			if (elementTop <= scrollBottom) {
				// Potential...
				makeActive = anchor;
				if (elementBottom > scrollTop) {
					// First one fully in view so let's stop here
					break;
				}
			}
		}
		if (makeActive !== undefined) {
			$anchor.parent().addClass(headingActiveClass);
		}
	}).run);

	function activateHeadingHandlers() {
		$anchors.on('click.scrollTo', function(event) {
			// event.preventDefault();

			var anchor = this.href.substring(this.href.indexOf('#') + 1);
			var selectedGroup = $('#' + anchor );

			// Temporarily turn off changing the class of the active item on the left
			enabled = false;

			// Animate scroll to selected group
			$('html, body').animate(
				{scrollTop: selectedGroup.offset().top - defaultPadding},
				'slow',
				function() {
					// Now that the animation is done renable switching what is selected on left
					enabled = true;
				}
			);
		});
	}

	function deactivateHeadingHandlers() {
		$anchors.off('click.scrollTo');
	}

	/* Events */
	$(window).on('ViewportTracker:breakpoint', function() {
		breakpoint = ViewportTracker.getBreakpoint();
		if ( breakpoint <= parseInt(variables.screen_sectionHasAside_stack, 10) ) {
			deactivateHeadingHandlers();
		} else {
			activateHeadingHandlers();
		}
	});
}

module.exports = {
	init: StickyNav
};
